import { Component, OnInit, Input } from '@angular/core';
import config from './habilitationCaces.json';
import * as moment from 'moment';
import { SessionService } from '../../../../services/session/session.service';
declare let UIkit: any;

@Component({
  selector: 'ags-habilitation-caces-ac',
  templateUrl: './habilitation-caces-ac.component.html',
  styleUrls: ['./habilitation-caces-ac.component.scss']
})
export class HabilitationCacesAcComponent implements OnInit {
  public opened = false;
  public setDp = false;
  public infoApprenant: any;
  public infoHabilitation: any;
  public infoCategorie: any = {};
  public config: any = config;
  public target: string;
  public habilitaionApprenant: any;
  public certificats: any = [];

  // Informations de l'apprenant et de son habilitation
  @Input('infoApprenant')
  set _infoApprenant(value: any) {
    if (value) {
      this.infoApprenant = value;
    }
  }
  // Des informations générales sur les habilitations et le type d'habiltation du produit
  @Input('infoHabilitation')
  set _infoHabilitation(value: any) {
    if (value) {
      this.infoHabilitation = value;
    }
  }

  constructor(private sessionService: SessionService) {}

  ngOnInit() {
    this.config = config;
    this.target = this.infoHabilitation.type === 'AUTORISATION_CONDUITE' ? 'autorisationConduite' : 'caces';
    this.habilitaionApprenant = this.infoApprenant.habilitation[this.target];
    this.infoHabilitation.idSession = this.infoApprenant.id_session;
    this.formatDates();
  }

  // Formatter les dates des évaluations
  formatDates() {
    this.habilitaionApprenant.theorie.date = new Date(this.habilitaionApprenant.theorie.date);
    Object.keys(this.habilitaionApprenant.pratique).map(key => {
      this.habilitaionApprenant.pratique[key].date = new Date(this.habilitaionApprenant.pratique[key].date);
      // Si ce n'est pas une date
      if (typeof this.habilitaionApprenant.pratique[key].dateExpiration === 'object') {
        this.habilitaionApprenant.pratique[key].dateExpiration = null;
      } else {
        this.habilitaionApprenant.pratique[key].dateExpiration = new Date(
          this.habilitaionApprenant.pratique[key].dateExpiration
        );
      }
    });
  }

  getCategorie(idCategorie) {
    return this.infoHabilitation.categories.filter(e => Number(e.id) === Number(idCategorie))[0].code;
  }

  // Récuppérer les propriétés d'une note
  getNote(prop, idNote) {
    const notes = (this.infoHabilitation.notes || []).filter(e => Number(e.id) === Number(idNote));
    return notes.length ? notes[0][prop] : '';
  }

  // Ouvrir la popup d'édition d'une catégorie
  open(categorie) {
    this.infoCategorie = categorie;
    this.opened = true;
  }

  getResultat(code) {
    return this.config.resultats.dataSource.filter(e => e.code === code)[0].libelle;
  }

  isDateValid(date) {
    return !isNaN(Date.parse(date));
  }
  // Sauvegarder l'habilitation de l'apprenant
  save() {
    const copyToSave = JSON.parse(JSON.stringify(this.infoApprenant));
    copyToSave.habilitation[this.target].theorie.date = new Date(
      copyToSave.habilitation[this.target].theorie.date
    ).getTime();

    Object.keys(this.habilitaionApprenant.pratique).map(key => {
      copyToSave.habilitation[this.target].pratique[key].date = moment(
        copyToSave.habilitation[this.target].pratique[key].date
      ).valueOf();
      if (this.isDateValid(copyToSave.habilitation[this.target].pratique[key].dateExpiration)) {
        copyToSave.habilitation[this.target].pratique[key].dateExpiration = new Date(
          copyToSave.habilitation[this.target].pratique[key].dateExpiration
        ).getTime();
      } else {
        copyToSave.habilitation[this.target].pratique[key].dateExpiration = null;
      }
    });

    // Mettre à jour l'habilitation
    this.sessionService
      .updateSessionApprenantHabilitation(this.infoApprenant.id, this.infoApprenant.habilitation)
      .subscribe(
        () => {
          if (this.certificats.length) {
            // Sauvegarder les cértificats
            this.sessionService.saveCertificats(this.certificats).subscribe(() => {
              this.certificats = [];
            });
          }
          UIkit.notification({ message: 'Données sauvegardées', pos: 'top-right' });
        },
        () => {
          UIkit.notification({ message: 'une erreur est survenue', pos: 'top-right', status: 'danger' });
        }
      );
  }

  // Permet de fermer la popup avec une sauvegarde des données
  callbackSave($event) {
    this.habilitaionApprenant.pratique[$event.key] = $event.categorie;
    // Si on a généré un certificat
    if ($event.bCertificat) {
      this.certificats.push($event.certificat);
    }
    this.opened = false;
  }

  // fermer la popup d'édition des évaluations
  closePopup() {
    this.opened = false;
  }
}
